export const ONEROSO_GET_REQUESTING = 'ONEROSO_GET_REQUESTING';
export const ONEROSO_GET_SUCCESS = 'ONEROSO_GET_SUCCESS';
export const ONEROSO_GET_ERROR = 'ONEROSO_GET_ERROR';
export const ONEROSO_FIND_BY_ID = "ONEROSO_FIND_BY_ID";
export const ONEROSO_SET_CREDIT_ID_REQUESTING = "ONEROSO_SET_CREDIT_ID_REQUESTING";
export const ONEROSO_SET_CREDIT_ID_SUCCESS = "ONEROSO_SET_CREDIT_ID_SUCCESS";
export const ONEROSO_SET_CREDIT_ID_ERROR = "ONEROSO_SET_CREDIT_ID_ERROR";